import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { DreMenuProps } from 'pages/financeiro/dre/types';

export function useQueryGrupos() {
    const requestListagem = useRequestListagem();

    return useQuery<DreMenuProps[]>(['queryGrupos'], () =>
        requestListagem({
            url: '/dre/tipodremercadologicagrupoexibicao/agrupamento',
            sort: [{ property: 'nrSequencia', direction: 'ASC' }],
        }).then((res) => res.data.data),
    );
}
